<template>
	<transition name="fade">
		<div class="iv2-loading">
			<loading :active.sync="isLoading" :can-cancel="false" loader="dots"></loading>
		</div>
	</transition>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
	data() {
		return {
			isLoading: true
		};
	},

	components: {
		Loading
	}
};
</script>

<style lang="scss">
.iv2-loading {
	height: 100vh;
}
</style>